/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 18th 2023, 4:01:33 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TRIAL_DAYS } from "config";
import { STATUS_CODES } from "lib/api/types";
import { Organization } from "lib/schemas";
import { convertUnixTimestampToDate } from "lib/utils";
import { useSaaSSubscriptionAPI } from "saas-subscription/services/SubscriptionAPI";

export const useSubscribeWithoutPay = (selectedOrganization: Organization, overriden_trial_days?: number) => {
  const { useCreateSubscription } = useSaaSSubscriptionAPI();
  const {
    createSubscription,
    isMakingAPIRequest,
    isAPIError: isCreateSubscriptionAPIError,
    httpResponseStatusCode: createSubscriptionAPIResponseCode,
    subscriptionCreationResponse,
  } = useCreateSubscription();

  const isClientError =
    isCreateSubscriptionAPIError &&
    STATUS_CODES.ClientError <= createSubscriptionAPIResponseCode &&
    createSubscriptionAPIResponseCode < STATUS_CODES.ServerError;

  const isSuccessful = Boolean(subscriptionCreationResponse?.subscription_id);

  const trialStartDate = convertUnixTimestampToDate(subscriptionCreationResponse?.trial_start);
  const trialEndDate = convertUnixTimestampToDate(subscriptionCreationResponse?.trial_end);

  return {
    handlePurchase: ({ selectedPrice }) => {
      let trial_period_days = overriden_trial_days === undefined ? parseInt(TRIAL_DAYS) : overriden_trial_days;
      trial_period_days = !isNaN(trial_period_days) ? trial_period_days : 0;
      createSubscription({
        trial_period_days,
        organization: selectedOrganization,
        lookup_key: selectedPrice.lookup_key,
      });
    },
    isError: isClientError,
    isMakingPurchase: isMakingAPIRequest,
    isSuccessful,
    trialStartDate,
    trialEndDate,
  };
};
